import {
  SET_ERROR,
  REMOVE_ERROR,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  errorList: [],
}

function setError(state, action) {
  return {
    ...state,
    errorList: [action.payload.errorObject, ...state.errorList],
  }
}

function removeError(state, action) {
  const { errorList: oldErrorList } = state

  const error = oldErrorList.find(err => err.name === action.payload.errorName)
  const errorIndex = oldErrorList.indexOf(error)

  const errorList = [...oldErrorList]
  errorList.splice(errorIndex, 1)

  return {
    ...state,
    errorList,
  }
}

// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ERROR:
      return setError(state, action)
    case REMOVE_ERROR:
      return removeError(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
